var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-box uni-login" }, [
    _c("div", { staticClass: "login-container login-cont" }, [
      _vm._m(0),
      _c("div", { staticClass: "cont-r" }, [
        _vm.isShowPort == 1
          ? _c("div", { staticClass: "btn-box" }, [
              _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      return _vm.choicePortClick("adult")
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "btn-icon",
                    attrs: {
                      src: require("@/assets/images/choice_port1.png"),
                      alt: "",
                    },
                  }),
                  _c("span", { staticClass: "text" }, [
                    _vm._v("成人高等教育入口"),
                  ]),
                  _c("img", {
                    staticClass: "btn-arrow",
                    attrs: {
                      src: require("@/assets/images/login-arrow.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn",
                  on: {
                    click: function ($event) {
                      return _vm.choicePortClick("own")
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "btn-icon",
                    attrs: {
                      src: require("@/assets/images/choice_port2.png"),
                      alt: "",
                    },
                  }),
                  _c("span", { staticClass: "text" }, [_vm._v("自学考试入口")]),
                  _c("img", {
                    staticClass: "btn-arrow",
                    attrs: {
                      src: require("@/assets/images/login-arrow.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ])
          : _vm.isShowPort == 2
          ? _c(
              "div",
              { staticClass: "login-content" },
              [
                _c("div", { staticClass: "title-box" }, [
                  _c(
                    "div",
                    {
                      staticClass: "login-content_icon",
                      on: { click: _vm.backClick },
                    },
                    [_c("i", { staticClass: "el-icon-arrow-left" })]
                  ),
                  _c("div", { staticClass: "login-content_title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("portValueFilter")(_vm.portValue)) +
                        " "
                    ),
                  ]),
                ]),
                _c(
                  "el-tabs",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isActive,
                        expression: "!isActive",
                      },
                    ],
                    staticClass: "uni-tabs",
                    model: {
                      value: _vm.activeName,
                      callback: function ($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName",
                    },
                  },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "密码登陆", name: "first" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "ruleForm",
                            attrs: { model: _vm.ruleForm, rules: _vm.rules },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "uni-input-group" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "uni-label",
                                    class: {
                                      active:
                                        _vm.isLabelActive == "account" ||
                                        _vm.ruleForm.account != "",
                                    },
                                    on: { click: _vm.inputGroupClick },
                                  },
                                  [_vm._v("手机号/学号")]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "uni-input",
                                    attrs: { prop: "account" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        name: "account",
                                        type: "text",
                                        autocomplete: "new-password",
                                      },
                                      on: {
                                        focus: _vm.changeLabelFocus,
                                        blur: _vm.changeLabelBlur,
                                      },
                                      model: {
                                        value: _vm.ruleForm.account,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "account",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "ruleForm.account",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "uni-input-group" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "uni-label",
                                    class: {
                                      active:
                                        _vm.isLabelActive == "password" ||
                                        _vm.ruleForm.password != "",
                                    },
                                    on: { click: _vm.inputGroupClick },
                                  },
                                  [_vm._v("密码")]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "uni-input",
                                    attrs: { prop: "password" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        autocomplete: "new-password",
                                        name: "password",
                                        type: _vm.isOpen,
                                      },
                                      on: {
                                        focus: _vm.changeLabelFocus,
                                        blur: _vm.changeLabelBlur,
                                      },
                                      model: {
                                        value: _vm.ruleForm.password,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "password",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.password",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isOpen == "password",
                                      expression: "isOpen == 'password'",
                                    },
                                  ],
                                  staticClass: "iconfont iconclose_eyes_",
                                  on: { click: _vm.showPassword },
                                }),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isOpen == "text",
                                      expression: "isOpen == 'text'",
                                    },
                                  ],
                                  staticClass: "iconfont iconyanjing",
                                  on: { click: _vm.showPassword },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "uni-input-group" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "uni-label",
                                    class: {
                                      active:
                                        _vm.isLabelActive == "verify_code" ||
                                        _vm.ruleForm.verify_code != "",
                                    },
                                    on: { click: _vm.inputGroupClick },
                                  },
                                  [_vm._v("验证码")]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "uni-input",
                                    attrs: { prop: "verify_code" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "60%" },
                                          attrs: {
                                            clearable: "",
                                            name: "verify_code",
                                            type: "text",
                                          },
                                          on: {
                                            focus: _vm.changeLabelFocus,
                                            blur: _vm.changeLabelBlur,
                                          },
                                          nativeOn: {
                                            keyup: function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              return _vm.refer("密码")
                                            },
                                          },
                                          model: {
                                            value: _vm.ruleForm.verify_code,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "verify_code",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "ruleForm.verify_code",
                                          },
                                        }),
                                        _c("img", {
                                          staticClass: "img",
                                          staticStyle: {
                                            width: "40%",
                                            cursor: "pointer",
                                          },
                                          attrs: {
                                            src: _vm.verifyCodeData
                                              .verifyCodeImg,
                                            alt: "",
                                          },
                                          on: { click: _vm.getCodeData },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-link",
                              {
                                staticStyle: {
                                  float: "right",
                                  color: "#5879ff",
                                },
                                attrs: { type: "info" },
                                on: { click: _vm.handleForgetPwd },
                              },
                              [_vm._v("忘记密码 ")]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "refer-btn",
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.refer("密码")
                                  },
                                },
                              },
                              [_vm._v("登陆 ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "验证码登陆", name: "second" } },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "codeForm",
                            attrs: {
                              model: _vm.codeForm,
                              rules: _vm.codeRules,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "uni-input-group" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "uni-label",
                                    class: {
                                      active:
                                        _vm.isLabelActive == "mobile" ||
                                        _vm.codeForm.mobile != "",
                                    },
                                    on: { click: _vm.inputGroupClick },
                                  },
                                  [_vm._v("手机号")]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "uni-input",
                                    attrs: { prop: "mobile" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        clearable: "",
                                        autocomplete: "off",
                                        name: "mobile",
                                      },
                                      on: {
                                        focus: _vm.changeLabelFocus,
                                        blur: _vm.changeLabelBlur,
                                      },
                                      model: {
                                        value: _vm.codeForm.mobile,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.codeForm,
                                            "mobile",
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                          )
                                        },
                                        expression: "codeForm.mobile",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "uni-input-group" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "uni-label",
                                    class: {
                                      active:
                                        _vm.isLabelActive == "code" ||
                                        _vm.codeForm.code != "",
                                    },
                                    on: { click: _vm.inputGroupClick },
                                  },
                                  [_vm._v("验证码")]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "uni-input",
                                    attrs: { prop: "code" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        autocomplete: "off",
                                        name: "code",
                                      },
                                      on: {
                                        focus: _vm.changeLabelFocus,
                                        blur: _vm.changeLabelBlur,
                                      },
                                      nativeOn: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.refer("验证码")
                                        },
                                      },
                                      model: {
                                        value: _vm.codeForm.code,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.codeForm, "code", $$v)
                                        },
                                        expression: "codeForm.code",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "uni-code",
                                    attrs: { round: "", disabled: _vm.isTimer },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getCode(60)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        !_vm.isTimer
                                          ? "获取验证码"
                                          : `(${_vm.timerCount}s) 重发`
                                      ) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "refer-btn",
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.refer("验证码")
                                  },
                                },
                              },
                              [_vm._v("登陆 ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-box" }, [
      _c("img", {
        staticClass: "logo-img",
        attrs: { src: require("@/assets/images/logo.png"), alt: "" },
      }),
      _c("img", {
        staticClass: "login-cont-img",
        attrs: { src: require("@/assets/images/login-cont-img.png"), alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }